// TODO: PAT-2250 "yarn remove react-loadable" (in hotfix branch) if this works properly
import loadable from '@loadable/component'

export default (importFunc) => {
  return loadable(importFunc)
}
